import qs from 'qs'
import { useEffect } from 'react'
import { generatePath, useNavigate } from 'react-router'

import { routeName } from '~/@common/constants'
import { nativeEventBus } from '~/@common/services/nativeEventBus'
import { localStorageService } from '~/@common/services/storage.service'

/**
 * 네이티브 앱 → 웹뷰 내비게이션 이벤트 구독 훅.
 * QR 채점, 강의 딥링크, 시그니처 강좌 딥링크를 처리한다.
 *
 * 이벤트 수신은 nativeEventBus가 앱 초기화 시점에 일괄 등록하므로
 * ready() 이전 이벤트 유실 걱정 없이, 필요한 페이지에서 구독만 하면 된다.
 */
export const useNativeEventBridge = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // QR 스캔 → 학습지 채점 페이지 이동
    const unsubQR = nativeEventBus.subscribe('onQRCodeReceived', (e) => {
      const { worksheetId, dateTime } = e.detail ?? {}
      localStorageService.clearIsInitialPassword()
      if (worksheetId && dateTime) {
        navigate(
          `${generatePath(routeName.qrWorksheet.scoring, { worksheetId, dateTime })}?size=all`,
        )
      }
    })

    // 딥링크 → 강의 상세 페이지 이동
    const unsubLecture = nativeEventBus.subscribe('onVideoIdReceived', (e) => {
      const lectureId = e.detail?.videoId
      localStorageService.clearIsInitialPassword()
      if (lectureId) {
        navigate(
          `${generatePath(routeName.student.lectureDetail, { lectureId })}?hideList=true`,
        )
      }
    })

    // 딥링크 → 시그니처 강좌 목록 이동
    const unsubSignature = nativeEventBus.subscribe('onSignatureBookReceived', (e) => {
      const { signatureType, curriculumKey } = e.detail ?? {}
      localStorageService.clearIsInitialPassword()
      if (signatureType && curriculumKey) {
        const params = qs.stringify({ curriculumKey }, { addQueryPrefix: true })
        navigate(routeName.student.signatureWorkbookLectureList + params)
      }
    })

    return () => {
      unsubQR()
      unsubLecture()
      unsubSignature()
    }
  }, [])
}
